export const toFirestore = mailToSave => {
  return {
    mail: { ...mailToSave },
  };
};
